import React, { ReactNode } from 'react';
import { useController } from 'react-hook-form';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import { SettingsComponent } from '../../lib/declarations/EditorComponentTypes';
import { BlockSpecificPage } from '../../lib/declarations/BlockSpecificPage';
import { useCurrentBlock } from '../CurrentBlockProvider';
import ViewTypeSelector from '../../lib/components/settings/ViewTypeSelector';
import { EventsBlock, EventsViewType } from '../../../declarations/models/blocks/EventsBlocks';

const VARIANT_ICONS: Record<EventsViewType, ReactNode> = {
  [EventsViewType.GRID]: <MaterialSymbol name='view_module' />,
  [EventsViewType.LIST]: <MaterialSymbol name='view_list' />,
};

export const PageBlockEventListViewTypeSelector: SettingsComponent = () => {
  const { blockPath } = useCurrentBlock();

  const {
    field: { value: selectedViewType, onChange: setSelectedViewType },
  } = useController<BlockSpecificPage<EventsBlock>, `${typeof blockPath}.view`>({ name: `${blockPath}.view` });

  return (
    <ViewTypeSelector
      viewType={selectedViewType}
      viewTypes={Object.values(EventsViewType)}
      onChange={setSelectedViewType}
      variantIcons={VARIANT_ICONS}
      variantTranslationPath='EventListViewTypeSelector'
    />
  );
};

export default PageBlockEventListViewTypeSelector;
